import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";

import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import AboutSection from "./Components/About";
import OurServices from "./Components/Services";
import KaizenCard from "./Components/KaizenCard";
import ContactPage from "./Components/Contact";
import Footer from "./Components/Footer";
import Owner from "./Components/ht/Owner";
import Login from "./Components/ht/Login";
import EventDetails from "./Components/ht/EventDetails";
import Blog from "./Components/ht/Blog";
import ProtectedRoute from "./Components/ht/ProtectedRoute";
import Admin from "./Components/ht/Admin";
import Blogger from "./Components/ht/Blogger";
import Event from "./Components/ht/Event";
import BlogHistory from "./Components/ht/BlogHistory";

function Layout({ children }) {
  const location = useLocation();
  const path = location.pathname.toLowerCase();

  // Hide navbar on these routes
  const hideNavbarPaths = ["/login", "/owner", "/admin", "/blogger"];
  const showNavbar = !hideNavbarPaths.includes(path);

  return (
    <>
      {showNavbar && <Navbar />}
      {children}
    </>
  );
}

function MainSections() {
  return (
    <div className="App">
      <div id="home">
        <Home />
      </div>
      <div id="about">
        <AboutSection />
      </div>
      <div id="services">
        <OurServices />
      </div>
      <div id="kaizen">
        <KaizenCard />
      </div>
      <div id="contact">
        <ContactPage />
      </div>
      <div id="footer">
        <Footer />
      </div>
      <div id="eventdetails">
        <EventDetails />
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <Layout>
          <Routes>
            {/* ✅ Main sections page */}

            <Route path="/" element={<MainSections />} />

            {/* ✅ Other public routes */}

            <Route path="/event" element={<Event />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/bloghistory/:id" element={<BlogHistory />} />
    
            <Route path="/login" element={<Login />} />
            <Route path="/event-details" element={<EventDetails />} />

            {/* ✅ Protected routes */}
            <Route
              path="/owner"
              element={
                <ProtectedRoute allowedRoles={["owner"]}>
                  <Owner />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute allowedRoles={["admin"]}>
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blogger"
              element={
                <ProtectedRoute allowedRoles={["blogger"]}>
                  <Blogger />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
